/**
 * Returns a short timezone offset label for the current browser timezone (e.g. "GMT+5:30", "GMT-8:00").
 * Only safe to call on the client; returns empty string when offset cannot be determined.
 */
export function getTimezoneOffsetLabel() {
    if (typeof window === 'undefined') return '';
    const offsetMinutes = -new Date().getTimezoneOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const absMinutes = Math.abs(offsetMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;
    if (minutes === 0) {
        return `GMT${sign}${hours}`;
    }
    return `GMT${sign}${hours}:${minutes.toString().padStart(2, '0')}`;
}
